import { landmineNames } from '@mm/constants/landmine-names';
import { getIsAutomationFeatureEnabled } from '@mm/state/selectors/automations';
import classNames from 'classnames';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../common/buttons/PrimaryButton/PrimaryButton';
import {
  Countdown,
  ParsedTimeLeft,
} from '../../../common/components/Countdown/Countdown';
import { useFreeTrialUpgradeModal } from '../../../common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import './FreeTrialCountdown.pcss';

export const FreeTrialCountdown = () => {
  const { freeTrialPromotion, currentSubscription, allowedToManageBilling } =
    useFreeTrialUpgradeModal();
  const isAutomationsEnabled = useSelector(getIsAutomationFeatureEnabled);
  const [parsedTimeLeft, setParsedTimeLeft] = useState<ParsedTimeLeft>();
  const { openFreeTrialUpgradeModalPromotional } = useFreeTrialUpgradeModal();

  if (!freeTrialPromotion?.expiresAt) return null;

  const labelText = isAutomationsEnabled
    ? 'Free Trial expires in'
    : 'Free trial:';

  return (
    <div className="free-trial-countdown__with-automations__wrapper">
      {isAutomationsEnabled && (
        <div className="free-trial-countdown__with-automations_left" />
      )}
      <div
        className={classNames('free-trial-countdown', {
          'free-trial-countdown__with-automations': isAutomationsEnabled,
        })}
      >
        <div
          className={classNames('free-trial-countdown__label', {
            'free-trial-countdown__label-with-automations':
              isAutomationsEnabled,
          })}
        >
          {labelText}
        </div>
        <Countdown
          expiresAt={freeTrialPromotion.expiresAt}
          parsedTimeLeft={parsedTimeLeft}
          setParsedTimeLeft={setParsedTimeLeft}
          withSeconds={!isAutomationsEnabled}
          css={
            isAutomationsEnabled
              ? {
                  countdownDays: 'free-trial-countdown__days',
                  countdownDaysText: 'free-trial-countdown__days-text',
                  countdownHoursAndMinutes: 'free-trial-countdown__time',
                }
              : {}
          }
        />
        {allowedToManageBilling &&
          !(currentSubscription && Object.keys(currentSubscription).length) && (
            <div className="free-trial-countdown__button-container">
              <PrimaryButton
                color={ButtonColor.secondaryBlue}
                onClick={() =>
                  openFreeTrialUpgradeModalPromotional({
                    landmineName: landmineNames.FREE_TRIAL_EXTEND_BUTTON,
                  })
                }
                className={
                  isAutomationsEnabled ? 'free-trial-countdown__button' : ''
                }
              >
                Extend
              </PrimaryButton>
            </div>
          )}
      </div>
      {isAutomationsEnabled && (
        <div className="free-trial-countdown__with-automations_right" />
      )}
    </div>
  );
};
